export default "__VITE_PUBLIC_ASSET__349dd0e2__"